import { Inject, Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { Constants } from '../Constants';

@Injectable()
export class Registration {
    private serviceUrl: string = this._claims.SMUrl + "breeze/Registration/";
    private jsonHeaders: Headers

    constructor(private _http: Http, @Inject('Claims') private _claims: any) {
        this.jsonHeaders = new Headers();
        this.jsonHeaders.append('Accept', 'application/json');
        this.jsonHeaders.append('Content-Type', 'application/json');
    }

    public createRegistrationRequest() {
        return this._http.get(this.serviceUrl + "RegistrationRequest", { headers: this.jsonHeaders }).map(res => res.json());
    }

    public submitRegistrationRequest(request) {
        return this._http.post(this.serviceUrl + "RegistrationRequest", JSON.stringify(request), { headers: this.jsonHeaders }).map(res => res.json());
    }

    public createExternalRegistrationRequest() {
        return this._http.get(this._claims.BaseUrl + "identity/ExternalRegistration", { headers: this.jsonHeaders }).map(res => res.json());
    }

    public submitExternalRegistrationRequest(request) {
        return this._http.post(this._claims.BaseUrl + "identity/ExternalRegistration", JSON.stringify(request), { headers: this.jsonHeaders }).map(res => res.json());
    }

    public verifyCompany(Name: string) {
        return this._http.get(this.serviceUrl + "VerifyCompany?Name=" + Name, { headers: this.jsonHeaders }).map(res => res.json());
    }

    public verifyNewUsername(Name: string, Company: string) {
        return this._http.get(this.serviceUrl + "VerifyNewUsername?Username=" + Name + "&CompanyName=" + Company, { headers: this.jsonHeaders }).map(res => res.json());
    }

    public createResetPasswordRequest() {
        return this._http.get(this.serviceUrl + "ResetPasswordRequest", { headers: this.jsonHeaders }).map(res => res.json());
    }

    public submitResetPasswordRequest(request) {
        return this._http.post(this.serviceUrl + "ResetPasswordRequest", JSON.stringify(request), { headers: this.jsonHeaders }).map(res => res.json());
    }

    public verifyResetPasswordRequest(request) {
        return this._http.post(this.serviceUrl + "VerifyResetPasswordRequest",
            JSON.stringify(request),
            { headers: this.jsonHeaders })
            .toPromise()
            .then(r => {
                return r.json();
            },
                er => {
                    throw er.json();
                });
    }

    public submitResetPasswordVerifiedRequest(request) {
        return this._http.post(this.serviceUrl + "ResetPasswordVerifiedRequest", JSON.stringify(request), { headers: this.jsonHeaders }).map(res => res.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Services/Registration.ts